<template>
  <div class="card card-body">
    <!-- Comments -->
    <section>

      <!-- Main wrapper -->
      <div class="comments-list text-center text-md-left">
        <!-- First row -->
        <div class="comment-area recent-post">
          <h3 class="sidebar-title">4 ОТЗЫВА</h3>
          <!-- Single Comment Start -->
          <div class="single-comment">
            <div class="comment-img f-left pr-30">
              <img src="img/blog/user.jpg" alt="blog-comment">
            </div>
            <div class="comment-details fix">
              <h4><a href="#">ЕЛЕНА, Ставрополь</a></h4>
              <span>27 января 2022 в 20:13
</span>
              <p>Сегодня попробовали молочные продукты - молоко, сметану и сливочное масло. Все свежее, очень вкусное. Удобная доставка на дом. С удовольствием будем заказывать еще. Огромное спасибо.</p>
            </div>

          </div>
          <!-- Single Comment End -->
          <!-- Single Comment Start -->
          <div class="single-comment">
            <div class="comment-img f-left pr-30">
              <img src="img/blog/user.jpg" alt="blog-comment">
            </div>
            <div class="comment-details fix">
              <h4><a href="#">ОКСАНА, Ставрополь</a></h4>
              <span>26 марта 2022 в 15:26

</span>
              <p>
                Спасибо вам за Вашу поддержку и заботу о людях. Очень признательны Вам. Вкусная и полезная продукция. Всем рекомендую!!!</p>
            </div>

          </div>
          <!-- Single Comment End -->
          <!-- Single Comment Start -->
          <div class="single-comment">
            <div class="comment-img f-left pr-30">
              <img src="img/blog/user.jpg" alt="blog-comment">
            </div>
            <div class="comment-details fix">
              <h4><a href="#">ТАТЬЯНА, Ставрополь</a></h4>
              <span>24 мая 2022 в 16:04

</span>
              <p>
                Сегодня получила Вашу продукцию. Очень понравился сыр плавленый и качота. Отличный вкус Натурального молока. Масло домашнее, как в детстве. Удобная доставка. Удачи Вам, Чтобы Вы долго радовали нас своей продукцией.</p>
            </div>

          </div>
          <!-- Single Comment End -->
          <!-- Single Comment Start -->
          <div class="single-comment">
            <div class="comment-img f-left pr-30">
              <img src="img/blog/user.jpg" alt="blog-comment">
            </div>
            <div class="comment-details fix">
              <h4><a href="#">ВАЛЕНТИНА, Ставрополь</a></h4>
              <span>30 мая 2022 в 12:23

</span>
              <p>
                Получила молочные продукты (молоко, сметана, масло, творог, йогурт). Осталась очень довольна. Прежде всего, хотелось бы поблагодарить за качество продуктов. Сегодня это много значит. Молоко натуральное, вкусное, из него получается замечательная простокваша. Также заслуживает высокой оценки сметана и
                масло. Очень хорошо, что вы делаете творог не жирным, он получается вкусным и диетическим. Положительно то, что у вас есть доставка. Желаю вам успехов.</p>
            </div>

          </div>
          <!-- Single Comment End -->
        </div>
        <!-- First row -->
      </div>
      <!-- Main wrapper -->

      <h3 class="font-weight-bold text-muted text-center my-1">Оставьте свой отзыв на нашей электронной почте</h3>
      <h2 class="font-weight-bold text-muted text-center my-3">prav-product@yandex.ru</h2>

    </section>
    <!-- Section: Leave a reply (Not Logged In User) -->
  </div>
</template>

<script>
export default {
  name: "Reviews"
};
</script>

<style scoped>

</style>